import { Country } from "./api";

export interface FlatCountryData {
    countryIsoCode: string;
    countryName: string;
    regionIsoCode: string;
    regionName: string;
}

export function flattenCountryData(countries: Country[]) {
    return (countries || [])
        .map(c =>
            c.regions.map<FlatCountryData>(r => ({
                countryIsoCode: c.iso,
                countryName: c.name,
                regionIsoCode: r.iso,
                regionName: r.name
            }))
        )
        .reduce((result, item) => [...result, ...item], []);
}

export function lookupRegionInfo(countries: Country[], regionCode: string): FlatCountryData | undefined {
    return flattenCountryData(countries).find(d => d.regionIsoCode === regionCode);
}

export function validateEmail(email: string): boolean {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}
